// Centralized route constants to prevent typos and maintain consistency
export const ROUTES = {
  STUDENT: {
    HOME: '/student-home',
    MESSAGES: '/student/messages',
    PROFILE: '/student-profile',
    MOCK_TESTS: '/student/mock-tests',
  },
  INSTRUCTOR: {
    DASHBOARD: '/instructor',
    MESSAGES: '/instructor/messages',
    CALENDAR: '/instructor-calendar',
    BOOK_APPOINTMENT: '/instructor/book-appointment',
    DIARY: '/instructor-diary',
    SETTINGS: '/instructor/settings',
    ACCOUNT: '/instructor/account',
    PAYMENTS: '/instructor/payments',
    PAYMENT_DETAIL: '/instructor/payments/:studentId',
    STUDENTS: '/instructor/students',
    PROGRESS: '/instructor/students',
    PROGRESS_REPORT: '/instructor/progress-report/:reportId',
    MOCK_TEST: '/instructor/mock-test/:studentId',
    MOCK_TESTS: '/instructor/mock-tests/:studentId',
    NOTES: '/instructor/notes',
  },
  COMMON: {
    AUTH: '/auth',
    SKILLS: '/skills',
    DVSA_SKILLS: '/dvsa-skills',
    ACHIEVEMENTS: '/achievements',
    CAR_CONTROLS: '/car-controls',
    PROFILE: '/profile',
  },
} as const;

// Helper to get base path if needed for deployment
export const withBasePath = (path: string): string => {
  const basePath = import.meta.env.BASE_URL || '/';
  return basePath === '/' ? path : `${basePath}${path}`;
};
